import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormControl, FormGroupDirective } from '@angular/forms';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-polizas-juridas',
  templateUrl: './polizas-juridas.component.html',
  styleUrls: ['./polizas-juridas.component.scss']
})
export class PolizasJuridasComponent implements OnInit {

  cotizadorForm:FormGroup;

  contacto = [
    {
      img:"/assets/img/contacto/contacto3.svg",
      nombreOficina:"Oficina central",
      telefono: "558626-0911 / 558626-0912",
      boton:"Más información"
    },
    {
      img:"/assets/img/contacto/contacto1.svg",
      nombreOficina:"Centro de atención Norte",
      telefono: "554979-1215",
      boton:"Más información"
    },
    {
      img:"/assets/img/contacto/contacto2.svg",
      nombreOficina:"Jurídico y Extrajudicial",
      telefono: "558626-0912",
      boton:"Más información"
    }
  ];

  poliza = [
    {
      tipo:"Bronce",
      icono:"assets/img/polizasJuridicas/IconoBronce.svg",
      extrajudicial:"Vía extrajudicial",
      listExtrajudicial:["Cobranza de adeudos de rentas.","Asesoría en cualquier  incumplimiento de contrato.","Entrega del inmueble por terminación anticipada."],
      judicial:"Vía judicial",
      descripcionJudicial:"Recuperación legal del inmueble arrendado por:",
      listJudicial:["Falta de pago de renta.","Abandono."],
      listAdicional:[],
      boton:"Cotizar",
      class:"bronce"
    },
    {
      tipo:"Oro",
      icono:"assets/img/polizasJuridicas/IconoOro.svg",
      extrajudicial:"Vía extrajudicial",
      listExtrajudicial:["Cobranza de adeudos de rentas.","Asesoría en cualquier  incumplimiento de contrato.","Entrega del inmueble por terminación anticipada."],
      judicial:"Vía judicial",
      descripcionJudicial:"Recuperación legal del inmueble arrendado por:",
      listJudicial:["Falta de pago de renta.","Abandono.","Negativa a desocupación al vencimiento del contrato de  arrendamiento."],
      listAdicional:[],
      boton:"Cotizar",
      class:"oro"
    },
    {
      tipo:"Platino",
      icono:"assets/img/polizasJuridicas/IconoPlatino.svg",
      extrajudicial:"Vía extrajudicial",
      listExtrajudicial:["Cobranza de adeudos de rentas.","Asesoría en cualquier  incumplimiento de contrato.","Entrega del inmueble por terminación anticipada."],
      judicial:"Vía judicial",
      descripcionJudicial:"Recuperación legal del inmueble arrendado por:",
      listJudicial:["Falta de pago de renta.","Abandono.","Negativa a desocupación al vencimiento del contrato de  arrendamiento.","Cobranza judicial de adeudos de renta y servicios. "],
      listAdicional:[],
      boton:"Cotizar",
      class:"platino"
    },
    {
      tipo:"Adicionales",
      icono:"assets/img/polizasJuridicas/IconoAdicionales.svg",
      extrajudicial:"Vía extrajudicial",
      listExtrajudicial:[],
      judicial:"Vía judicial",
      descripcionJudicial:"",
      listJudicial:[],
      listAdicional:["Consulta de inmuebles ante el Registro Público de la Propiedad.","Consultas de Incidencias Legales adicionales.","Elaboración de contrato de arrendamiento sin emisión de póliza.","Elaboración de contrato de compra venta.","Asesoría Jurídica sin emisión de póliza.","Contáctanos y pregunta por las tarifas."],
      boton:"Cotizar",
      class:"adicionales"
    }
  ];

  prefixInput:boolean = false;
  costoPoliza:number = 0;
  procesando:boolean = false;

  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;

  constructor() { }

  sliderCarusel(type:string,complement:string) {
    if (type == "left") {
      $("#"+complement).carousel('next');
    }else {
      $("#"+complement).carousel('prev');
    }
  }

  aparecePrefijo(estado:boolean) {
    if (estado) {
      this.prefixInput = true;
      this.costoPoliza = 0;
    }else if(this.cotizadorForm.controls["importeRenta"].value == "") {
      this.prefixInput = false;
    }
  }

  selecionaCobertura(cobertura:number) {
    setTimeout(() => {
      this.cotizadorForm.reset();
      this.formGroupDirective.resetForm();
      this.costoPoliza = 0;
      this.prefixInput = false;
      switch (cobertura) {
        case 0:
          this.cotizadorForm.controls["cobertura"].setValue("bronce");
          break;
        case 1:
          this.cotizadorForm.controls["cobertura"].setValue("oro");
          break;
        case 2:
          this.cotizadorForm.controls["cobertura"].setValue("platino");
          break;
        default:
          break;
      }
    }, 0);
  }

  cotiza() {
    if(this.cotizadorForm.valid) {
      this.procesando = true;
      setTimeout(()=>{ 
        switch (this.cotizadorForm.controls["cobertura"].value) {
          case "bronce":
            if(parseInt(this.cotizadorForm.controls["importeRenta"].value) <= 10000) {
              this.costoPoliza = 4000;
            }else if(parseInt(this.cotizadorForm.controls["importeRenta"].value) > 10000 && parseInt(this.cotizadorForm.controls["importeRenta"].value) <= 30000) {
              this.costoPoliza = 4600;
            }else if(parseInt(this.cotizadorForm.controls["importeRenta"].value) > 30000){
              this.costoPoliza = parseInt(this.cotizadorForm.controls["importeRenta"].value) * .19;
            }
            break;
          case "oro":
            if(parseInt(this.cotizadorForm.controls["importeRenta"].value) <= 10000) {
              this.costoPoliza = 5400;
            }else if(parseInt(this.cotizadorForm.controls["importeRenta"].value) > 10000 && parseInt(this.cotizadorForm.controls["importeRenta"].value) <= 30000) {
              this.costoPoliza = 6200;
            }else if(parseInt(this.cotizadorForm.controls["importeRenta"].value) > 30000){
              this.costoPoliza = parseInt(this.cotizadorForm.controls["importeRenta"].value) * .24;
            }
            break;
          case "platino":
            if(parseInt(this.cotizadorForm.controls["importeRenta"].value) <= 10000) {
              this.costoPoliza = 10500;
            }else if(parseInt(this.cotizadorForm.controls["importeRenta"].value) > 10000 && parseInt(this.cotizadorForm.controls["importeRenta"].value) <= 30000) {
              this.costoPoliza = 12500;
            }else if(parseInt(this.cotizadorForm.controls["importeRenta"].value) > 30000){
              this.costoPoliza = parseInt(this.cotizadorForm.controls["importeRenta"].value) * .44;
            }
            break;
        
          default:
            break;
        }
        this.procesando = false;
      }, 1000);
    }else {
      $("#importeRenta").focus();
      $("#importeRenta").blur();
    }
  }

  
  ngOnInit(): void {
    this.cotizadorForm = new FormGroup({
      'cobertura':new FormControl('',[
        Validators.required
      ]),
      'importeRenta':new FormControl('',[
        Validators.pattern('^[0-9]*$'),
        Validators.required
      ])
    });
  }

}
